import { BORDER_COLORS } from "../../../../../components/Charts/constants";
import {
  byNumber,
  formatDate,
  sortRows,
  SortRule,
  toTone,
} from "../../../../../utils";
import { DateFormat } from "../../../../../utils/types";
import { Savings } from "../../../types";
import { SavingRow, SortKey, SortState } from "./types";

export const buildSavingsHoldings = (
  savings: Savings[],
  trendBySaving: Map<number, number[]>,
): SavingRow[] => {
  return savings.map((saving, index) => {
    return {
      id: saving.id,
      name: saving.name,
      accountLabel: saving.institution ?? saving.name,
      accountColor: BORDER_COLORS[index % BORDER_COLORS.length],
      since: formatDate(saving.startDate, DateFormat.DMY_SPACE),
      sinceValue: new Date(saving.startDate).getTime(),
      balance: saving.currentValue,
      deposited: saving.investedValue,
      withdrawn: saving.withdrawnValue,
      earned: saving.earnedValue,
      cashback: saving.cashbackValue,
      earnedTone: toTone(saving.earnedValue),
      trend: trendBySaving.get(saving.id) ?? [],
    };
  });
};

const SORT_RULES: Record<SortKey, SortRule<SavingRow>> = {
  since: byNumber((row) => row.sinceValue),
  balance: byNumber((row) => row.balance),
  deposited: byNumber((row) => row.deposited),
  withdrawn: byNumber((row) => row.withdrawn),
  earned: byNumber((row) => row.earned),
};

export const sortSavings = (rows: SavingRow[], sort: SortState): SavingRow[] =>
  sortRows(rows, SORT_RULES, sort);
